// Manage Club > Events tab. Mirrors screens/AdminScreen.js Events tab
// (list :689, create :959, edit :1164, delete :2033) on the shared services.
import React from "react";
import "../../../styles/manage-events.css";
import Modal, { ModalBody, ModalFooter } from "../../../components/Modal";
import { Button, Card, Empty, Seg, SkeletonRows } from "../../../components/primitives";
import { UpcomingCard, PastCard } from "./EventCards";
import EventFormModal from "./EventFormModal";
import CreatedModal from "./CreatedModal";
import CheckinQR from "./CheckinQR";
import AttendeesModal from "./AttendeesModal";
import useManageEvents from "./useManageEvents";
import { usePendingWork } from "../../../lib/pendingWork";
export default function EventsTab({ club, onClubChanged }) {
  const {
    uid, loading, error, filter, setFilter, form, setForm, created, setCreated, qrEvent, setQrEvent,
    attend, setAttend, toDelete, setToDelete, exporting, upcoming, past, load, canDelete,
    onCreated, onEdited, confirmDelete, exportSemester, closeQR, refreshCounts,
  } = useManageEvents({ club, onClubChanged });

  const pendingWork = usePendingWork();

  if (loading) return <SkeletonRows rows={3} />;
  if (error) {
    return (
      <Empty icon="alert" title="Couldn't load events">
        <p>{error}</p>
        <Button variant="sec" size="sm" onClick={() => load()} data-testid="manage.events.retry" style={{ marginTop: 10 }}>Retry</Button>
      </Empty>
    );
  }

  const list = filter === "upcoming" ? upcoming : past;
  return (
    <>
      <div className="row wrap" style={{ justifyContent: "space-between", marginBottom: 14 }}>
        <Seg
          label="Event filter"
          testId="manage.events.filter"
          value={filter}
          onChange={setFilter}
          options={[
            { value: "upcoming", label: "Upcoming", count: upcoming.length },
            { value: "past", label: "Past", count: past.length },
          ]}
        />
        <div className="row">
          {filter === "past" && (
            <Button variant="ghost" size="sm" icon="download" disabled={exporting} onClick={exportSemester} data-testid="manage.events.exportCsv">
              {exporting ? "Exporting…" : "Export CSV"}
            </Button>
          )}
          <Button variant="pri" size="sm" icon="plus" onClick={() => setForm({ event: null })} data-testid="manage.events.new">New event</Button>
        </div>
      </div>

      <div className="col">
        {list.map((e) =>
          filter === "upcoming" ? (
            <UpcomingCard
              key={e.id}
              event={e}
              canDelete={canDelete(e)}
              editLocked={pendingWork.has(`event:${e.id}`)}
              onQR={setQrEvent}
              onEdit={(ev) => setForm({ event: ev })}
              onDelete={setToDelete}
            />
          ) : (
            <PastCard
              key={e.id}
              event={e}
              onAdd={(ev) => setAttend({ event: ev, mode: "add" })}
              onView={(ev) => setAttend({ event: ev, mode: "view" })}
            />
          )
        )}
        {list.length === 0 && <Card className="empty">No events here.</Card>}
      </div>

      {form && (
        <EventFormModal
          club={club}
          event={form.event}
          uid={uid}
          onClose={() => setForm(null)}
          onCreated={onCreated}
          onEdited={onEdited}
        />
      )}
      {created && (
        <CreatedModal
          event={created.event}
          extra={created.extra}
          onClose={() => setCreated(null)}
          onViewQR={() => { setQrEvent(created.event); setCreated(null); }}
        />
      )}
      {qrEvent && <CheckinQR event={qrEvent} club={club} onClose={closeQR} />}
      {attend && (
        <AttendeesModal
          event={attend.event}
          club={club}
          mode={attend.mode}
          adminId={uid}
          onClose={() => setAttend(null)}
          onCountsChanged={refreshCounts}
        />
      )}
      {toDelete && (
        <Modal title="Delete Event" size="narrow" onClose={() => setToDelete(null)} testId="manage.events.deleteConfirm">
          <ModalBody>
            <p>Are you sure you want to delete <b>{toDelete.title}</b>? This action cannot be undone.</p>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" onClick={() => setToDelete(null)} data-testid="manage.events.deleteConfirm.cancel">Cancel</Button>
            <Button variant="dangerSolid" onClick={confirmDelete} data-testid="manage.events.deleteConfirm.confirm">Delete</Button>
          </ModalFooter>
        </Modal>
      )}
    </>
  );
}
